import { FundListSortColumn, SortDirection } from '@/types/fund.types';

interface SortHeaderProps {
  label: string;
  column: FundListSortColumn;
  activeColumn: FundListSortColumn;
  direction: SortDirection;
  onToggle: (column: FundListSortColumn) => void;
  className?: string;
}

/**
 * Replaces the repeated ion-icon + ion-label sort header blocks on the home
 * page. The whole header is the button now, rather than only the caret, which
 * gives a much larger target on touch.
 */
export function SortHeader({
  label,
  column,
  activeColumn,
  direction,
  onToggle,
  className = '',
}: SortHeaderProps) {
  const isActive = column === activeColumn;
  const isAscending = direction === SortDirection.ASCENDING;

  return (
    <button
      type="button"
      onClick={() => onToggle(column)}
      title={`Sort by ${label.toLowerCase()}`}
      aria-sort={isActive ? (isAscending ? 'ascending' : 'descending') : 'none'}
      className={`inline-flex items-center gap-1 rounded font-semibold text-slate-900 hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${className}`}
    >
      <Caret up={isActive && !isAscending} active={isActive} />
      <span>{label}</span>
    </button>
  );
}

function Caret({ up, active }: { up: boolean; active: boolean }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      aria-hidden="true"
      className={[
        'shrink-0 transition-transform',
        active ? 'text-primary' : 'text-slate-400',
        up ? 'rotate-180' : '',
      ].join(' ')}
    >
      <path d="M2 4l4 4 4-4z" fill="currentColor" />
    </svg>
  );
}
